(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('WorkqueueSearchController', WorkqueueSearchController);

  /* ngInject */
  function WorkqueueSearchController($location, $state, $stateParams, sessionService, workqueueService) {
    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.getResults = getResults;
    vm.loading = false;
    vm.order = $stateParams.order || 'relevant';
    vm.pageChange = pageChange;
    vm.query = $stateParams.query;
    vm.search = search;
    vm.searchResults = [];
    vm.totalCount = null;
    vm.startAt = $stateParams.startAt || '';
    vm.endAt = $stateParams.endAt || '';

    activate();

    function activate() {
      getResults();
    }

    function getResults() {
      vm.loading = true;
      vm.searchResults = [];

      workqueueService(sessionService.getAuthToken()).search({ query: vm.query, start_date: vm.startAt, end_date: vm.endAt, order: vm.order, page: vm.currentPage }, response => {
        vm.loading = false;
        vm.searchResults = response.search_results;
        vm.totalCount = response.meta.total_count;
      });
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.currentPage = newPageNumber;
      setLocation();
      getResults();
    }

    function search() {
      vm.currentPage = 1;
      $state.go('application.compliance_services.workqueue_search', {
        currentPage: vm.currentPage,
        query: vm.query,
        startAt: vm.startAt,
        endAt: vm.endAt,
        order: vm.order
      });
    }

    function setLocation() {
      $location.search({
        currentPage: vm.currentPage,
        query: vm.query,
        startAt: vm.startAt,
        endAt: vm.endAt,
        order: vm.order
      });
    }
  }
})();
